import React, { PropTypes, Component } from 'react';
import cx from 'classnames';
import classes from './index.scss';
import Youtube from '../../modules/youtube';

const randomValue = () => {
  return new Date().getTime() + Math.floor(Math.random() * 9999) + 100;
};

const playButtonSVG = (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="50px" x="0px" y="0px" viewBox="0 0 50 50">
    <g>
      <path id="Fill-5" fill="#F4F4F4" d="M49.7,24.7c0,13.5-11,24.5-24.5,24.5S0.7,38.3,0.7,24.7s11-24.5,24.5-24.5
        S49.7,11.2,49.7,24.7"/>
      <path id="Fill-7" fill="#3F484D" d="M18.9,34.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.3-0.3-0.5V15.9c0-0.2,0.1-0.4,0.3-0.5
        c0.2-0.1,0.4-0.1,0.6,0l16.5,8.9c0.2,0.1,0.3,0.3,0.3,0.5c0,0.2-0.1,0.4-0.3,0.5l-16.5,8.9C19.1,34.1,19,34.2,18.9,34.2"/>
    </g>
  </svg>
);

class YoutubePlayer extends Component {
  state = {
    player: null,
    embedReady: false,
    placeholderHidden: false,
  };

  componentWillMount() {
    this.id = `YTP-${ randomValue() }`;
    if (this.props.autoplay) this.setState({ placeholderHidden: true });
  }

  componentDidMount() {
    const options = {
      id: this.id,
      onApiReady: this.onApiReady,
      events: {
        onReady: this.onReady,
        onStateChange: this.onStateChange,
      },
    };
    Youtube.initPlayer(this.props.videoId, options);
  }

  onStateChange = (e) => {
    const videoEnded = e.data === 0;
    if(videoEnded) {
      this.setState({
        placeholderHidden: false,
      });
      if (this.props.autoplay) this.props.onVideoEnd();
    }
  };

  onReady = () => {
    this.setState({
      embedReady: true,
    });
    if (this.props.autoplay) this.state.player.playVideo();
  };

  onApiReady = (player) => {
    this.setState({
      player,
    });
  };

  getWrapperStyles() {
    const { width, height } = this.props;
    const wrapperStyles = {};

    if(width) wrapperStyles.width = `${width}px`;
    if(height) wrapperStyles.height = `${height}px`;
    return wrapperStyles;
  }

  embedSrc() {
    return `https://www.youtube.com/embed/${this.props.videoId}?enablejsapi=1`;
  }

  clickPlaceholder = () => {
    if (this.state.player && this.state.player.playVideo) {
      this.state.player.playVideo();
      this.setState({
        placeholderHidden: true,
      });
    }
  };

  render() {
    const placeholderClasses = cx({
      [classes.placeholder]: true,
      [classes.hide]: this.state.placeholderHidden,
    });

    const wrapperAttributes = {
      className: classes.youtubeWrapper,
      style: this.getWrapperStyles(),
    };

    const iframeClasses = cx({
      [classes.hide]: !this.state.placeholderHidden,
    });

    const iframeAttributes = {
      className: iframeClasses,
      id: this.id,
      width: '100%',
      height: '100%',
      src: this.embedSrc(),
      frameBorder: 0,
      allowFullScreen: true,
    };

    const placeholderStyles = {
      backgroundImage: `url(${this.props.placeholder})`,
    };

    const placeholderAttributes = {
      className: placeholderClasses,
      style: placeholderStyles,
      onClick: this.clickPlaceholder,
    };

    const headline = this.props.headline || '';

    return (
      <div { ...wrapperAttributes } >
        <iframe { ...iframeAttributes } />
        <div { ...placeholderAttributes }>
          <div className={ classes.placeholderContents } >
            <h2 className={ classes.headline } >{ headline }</h2>
            { playButtonSVG }
          </div>
        </div>
      </div>
    );
  }
}

YoutubePlayer.propTypes = {
  videoId: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  placeholder: PropTypes.string,
  headline: PropTypes.string,
  autoplay: PropTypes.bool,
  onVideoEnd: PropTypes.func,
};

export default YoutubePlayer;



/** WEBPACK FOOTER **
 ** ./shared-components/YoutubePlayer/index.js
 **/